import React from 'react'

import influencerData from '../../data-influencer/lisa2'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Lisa2 = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Lisa2
